<script setup>

</script>

<template>
  <header class="tl-header header-style-1">
    <div class="tl-topbar">
      <div class="container">
        <div class="d-flex justify-content-between">
          <div class="left-content">
            <ul class="global-list">
              <li><span class="icon"><img src="/static/picture/icon1.png" alt="Image" class="img-fluid"></span><a
                  href="tel:+8613802623082">+86 13802623082</a></li>
              <li><span class="icon"><img src="/static/picture/icon2.png" alt="Image" class="img-fluid"></span><a
                  href="mailto:dongxia52587@gmail.com">dongxia52587@gmail.com</a></li>
            </ul>
          </div><!-- /.left-content -->
          <div class="right-content align-self-center">
            <div class="topbar-user">
              <ul class="global-list">
                <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                <li><a href="#"><i class="fa fa-instagram"></i></a></li>
                <li><a href="#"><i class="fa fa-skype"></i></a></li>
              </ul>
            </div><!-- /.topbar-user -->
          </div><!-- /.right-content -->
        </div>
      </div><!-- /.container -->
    </div><!-- /.tl-topbar -->

    <div class="tl-menu menu-absolute menu-sticky">
      <nav class="navbar navbar-expand-lg p-0">
        <div class="container">
          <a class="navbar-brand" href="/">
            <img src="/static/picture/logo1.png" alt="Logo" class="img-fluid" style="width: 30%; height: 30%">
          </a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
                  aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"><i class="fa fa-align-justify"></i></span>
          </button>
          <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
            <ul class="navbar-nav">
              <li><a href="/">主页</a>
              </li>
              <li><a href="/about">关于我们</a></li>
              <li class="tl-dropdown">
                <a href="/products">产品</a>
                <ul class="tl-dropdown-menu">
                  <li class="tl-dropdown"><a href="/products/?primary_category=Aluminum Window">铝合金窗</a>
                    <ul class="tl-dropdown-menu">
                      <li><a href="/products/?secondary_category=Casement window">平开窗</a></li>
                      <li><a href="/products/?secondary_category=Sliding window">推拉窗</a></li>
                      <li><a href="/products/?secondary_category=Folding window">折叠窗</a></li>
                      <li><a href="/products/?secondary_category=Lift window">升降窗</a></li>
                      <li><a href="/products/?secondary_category=Skylight">天窗</a></li>
                    </ul>
                  </li>
                  <li class="tl-dropdown"><a href="/products/?primary_category=Aluminum Door">铝合金门</a>
                    <ul class="tl-dropdown-menu">
                      <li><a href="/products/?secondary_category=Swing door">平开门</a></li>
                      <li><a href="/products/?secondary_category=Sliding door">推拉门</a></li>
                      <li><a href="/products/?secondary_category=Folding door">折叠门</a></li>
                    </ul>
                  </li>
                  <li class="tl-dropdown"><a href="/products/?primary_category=Entrance door">入户门</a>
                    <ul class="tl-dropdown-menu">
                      <li><a href="/products/?secondary_category=Stainless Steel door">不锈钢门</a></li>
                      <li><a href="/products/?secondary_category=Precision-Engraved explosion-proof door">精密雕刻防爆门</a></li>
                    </ul>
                  </li>
                  <li class="tl-dropdown"><a href="/products/?primary_category=Interiot door">物联网门</a>
                    <ul class="tl-dropdown-menu">
                      <li><a href="/products/?secondary_category=Carbon Crystal Wooden door">碳水晶木门</a></li>
                    </ul>
                  </li>
                  <li><a href="/products/?primary_category=Sunroom">阳光房</a></li>
                </ul>
              </li>
              <li><a href="/blogs">博客</a></li>
              <li><a href="/contact">联系我们</a></li>
            </ul>
          </div>
          <div class="right-content">
            <div class="lt-button">
              <a href="/contact" class="btn btn-transparent">开始</a>
            </div>
          </div>
        </div><!-- /.container -->
      </nav><!-- /.navbar -->
    </div><!-- /.tl-menu -->
  </header><!-- /.tl-header -->
</template>

<style scoped lang="scss">

</style>